/**
 * React Query 캐시를 사용하지 않고, 마운트·쿼리 재구독 시마다 서버에서 새로 조회하는 옵션.
 * useQuery 의 options 에 그대로 전달한다.
 */
export const NO_CACHE_QUERY_OPTIONS = {
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
} as const;
